export const PAGE_DATA = {
  validAge: [16, 120],

  interestRateType: [
    'Fixed',
    'Variable'
  ],

  loanType: [
    {
      label: 'Live in it',
      name: 'Live',
      value: 'Live in it'
    },
    {
      label: 'Rent it out',
      name: 'Rent',
      value: 'Rent it out'
    }
  ],

  incomes: [
    {
      label: '$90,00 or less',
      desc: 'A 24.608% (Base tier) government rebate will be applied.',
      value: 'nil',
      rebate: 24.608,
      idSuffix: 'annualincome-nil'
    },
    {
      label: '$90,001 to $105,000',
      desc: 'A 16.405% (Tier 1) government rebate will be applied.',
      value: 'low',
      rebate: 16.405,
      idSuffix: 'annualincome-low'
    },
    {
      label: '$105,001 to $140,000',
      desc: 'A 8.202% (Tier 2) government rebate will be applied.',
      value: 'medium',
      rebate: 8.202,
      idSuffix: 'annualincome-medium'
    },
    {
      label: '$140,001 and over',
      desc: 'No government rebate (Tier 3) will be applied.',
      value: 'high',
      rebate: '0.00',
      idSuffix: 'annualincome-high'
    }
  ],

  didYouKnow: 'Our experts help you compare loans from over <strong>40 lenders</strong> to keep your repayments as low as possible.',

  homeFaqs: [
    {
      title: 'How much do I need for a deposit?',
      content: 'You’ll need a minimum deposit of 10 percent of the purchase price of a property to take out a home loan. But, it is more cost effective for you if you have a 20 percent deposit as this gives you more equity in your property and means less risk for your lender. This, in turn, can reduce the amount of interest that you’ll pay on your home loan.<br /><br />Plus, if you only have a 10 percent deposit, you may find that you’ll be asked to pay Lenders Mortgage Insurance (LMI), which is costly and can add thousands to your home loan principle. This insurance covers the lender against financial loss should you default on your home loan payments.'
    },
    {
      title: 'What home loan types are available?',
      content: 'There are numerous types of home loans in the industry. The most common are as follows:<br /><br />' +
      '<strong>Principal and interest:</strong> This is where you pay a portion of your home loan principle and the interest that your loan incurs monthly.<br /><br />' +
      '<strong>Interest only:</strong> This is where you only pay the interest on your home loan per month. At the end of your home loan you’ll pay back the principal you borrowed.<br /><br />' +
      '<strong>Variable rate:</strong> A home loan that has a rate that fluctuates with the rise and fall of the official cash rate.<br /><br />' +
      '<strong>Fixed rate:</strong> A home loan that has a fixed rate for an agreed term of usually 1, 2, 3 or 5 years. After the term ends the rate of the loan will revert to a variable rate.'
    },
    {
      title: 'What is a base-rate home loan?',
      content: 'This is a no-frills variable home loan that will give you the lowest possible rate. But, this home loan typically comes with no features.'
    },
    {
      title: 'What type of home loan should I be looking for?',
      content: 'The right home loan for you is the home loan that meets your needs and requirements, which gives you flexibility and is affordable. To find the right home loan, consider what home loan features you’ll use and what type of home loan you want. Then compare these home loans for the best rate.'
    },
    {
      title: 'What type of home loan features are available?',
      content: 'Home loan features give you payment flexibility, but typically the interest rate on home loans with features are slightly higher. The most common features you’ll encounter are:' +
      '<ul class="list-disc pl-4 my-8">' +
      '<li class="mb-4">Extra repayments without incurring a penalty.' +
      '<li class="mb-4">Offset accounts, where you can deposit all of your money into this account and the balance will then reduce your mortgage interest.' +
      '<li>A redraw facility, where any extra money paid off your home loan can be used at a later date as a loan if you need it.' +
      '</ul>'
    },
    {
      title: 'How much do I need for fees, charges and stamp duty?',
      content: 'All lenders charge different fees, so you’ll need to ask about these when you research home loans. Make sure you also ask about any other additional charges. <br /><br />Stamp duty depends on the value of the property you’re buying and what state the property is situated in. To calculate your stamp duty use an online calculator.'
    }]
}

export const ERROR_MAP = {
  home_loans: {
    interest_rate_type: 'Please select interest rate type',
    loan_type: 'Please select an option',
    income: 'Please select an option',
    interest_rate: 'Please enter your interest rate',
    outstanding_amount: 'Please enter your outstanding amount',
    loan_term: 'Please enter your remaining term',
    property_value: 'Please enter your property\'s current value'
  },

  form: {
    step1: {
      refinance: 'Please select an option',
      intending: 'Please select an option',
      postcode: 'Please enter your valid postcode'
    },
    step2: {
      refinance_purpose: 'Please select an option',
      buying_situation: 'Please select an option'
    },
    step3: {
      lender_reason: 'Please select an option'
    },
    step4: {
      property_value: 'Enter valid amount',
      loan_balance: 'Enter valid loan amount',
      interest_rate: 'Enter valid rate',
      loan_amount: 'Please enter a valid loan amount',
      deposit: 'Please enter a valid deposit amount',
      first_home: 'Please select an option'
    },
    step5: {
      interest_type: 'Please select an option',
      interest_type_loan: 'Please select an option'
    },
    step6: {
      buying_property: 'Please select an option',
      total_income: 'Enter valid amount',
      total_other_income: 'Enter valid amount'
    }
  },

  details: {
    full_name: 'Full name field is required.',
    email: 'Please enter a valid email address.',
    phone: 'Please enter a valid number.'
  }
}

export const SUMMARY_MAP = {
  loan_type: {
    label: 'Live / rent'
  }
}

export const QUESTIONS = {
  interestRateType: {
    question: 'What is your current interest rate type?',

    component: 'MoleculesSelection',
    props: {
      name: 'interest_rate_type',
      type: 'radio',
      ticker: 'circle',
      options: PAGE_DATA.interestRateType
    }
  },
  interestRate: {
    question: 'What is your current interest rate on your home loan?',

    component: 'AtomsInput',
    props: {
      name: 'interest_rate',
      placeholder: 'Enter interest rate',
      modelType: 'money',
      label: '',
      hasPercentage: true
    }
  },
  outstandingAmount: {
    question: 'What is the current amount outstanding on your home loan?',

    component: 'AtomsInput',
    props: {
      name: 'outstanding_amount',
      placeholder: 'Enter amount',
      modelType: 'money',
      label: '',
      hasCurrency: true
    }
  },
  loanTerm: {
    question: 'What is the remaining term of your home loan?',
    desc: 'Term range 1 year - 30+ years',

    component: 'AtomsInput',
    props: {
      name: 'loan_term',
      placeholder: 'Enter home loans term',
      modelType: 'number',
      maxlength: '2',
      label: ''
    }
  },
  propertyValue: {
    question: 'What is your property\'s current value?',

    component: 'AtomsInput',
    props: {
      name: 'property_value',
      placeholder: 'Enter your current property value',
      modelType: 'money',
      label: '',
      hasCurrency: true
    }
  },
  loanType: {
    question: 'Do you live in or rent out your home?',

    component: 'MoleculesSelection',
    props: {
      name: 'loan_type',
      type: 'radio',
      ticker: 'circle',
      options: PAGE_DATA.loanType
    }
  },
  income: {
    question: 'How much is your household annual income?',
    component: 'MoleculesSelection',
    props: {
      name: 'income',
      type: 'radio',
      ticker: 'circle',
      options: PAGE_DATA.incomes
    }
  }
}

export const FORM_PAGE_DATA = {
  quickTips: [
    'Our panel of <strong>40+ lenders</strong> is one of the biggest in Australia. We compare all the big banks you already know and some specialist lenders other brokers don’t offer.',
    'We\'re mortgage brokers, and we\'re not owned by a big bank or a home loan provider. That means we\'ve only got your best interests in mind. <strong>Our mission is to find you the best loan</strong>, not the mortgage that makes us the most money.'
  ]
}

export const HOME_LOANS_FORM_ITEMS = {
  step1: {
    header: {
      title: 'Tell us a bit more about <strong>what you\'re looking for.</strong>',
      component: 'AtomsHeadline'
    },
    buttons: {
      back: true,
      main: 'Continue'
    },
    form: (() => {
      const refinance = {
        question: 'What is the loan purpose?',
        component: 'MoleculesSelection',
        props: {
          name: 'refinance',
          type: 'radio',
          cols: 2,
          mobileCols: 1,
          ticker: 'circle',
          options: [
            {
              value: '1',
              label: 'Refinance',
              name: 'refinanceInput'
            }, {
              value: '0',
              label: 'Purchase',
              name: 'Purchase'
            }
          ]
        }
      }

      const intending = {
        question: 'What will your property be used for?',
        component: 'MoleculesSelection',
        props: {
          name: 'intending',
          type: 'radio',
          cols: 2,
          mobileCols: 1,
          ticker: 'circle',
          options: [
            {
              value: 'OwnerOccupied',
              label: 'Live in it',
              name: 'OwnerOccupied'
            }, {
              value: 'Investment',
              label: 'Rent it out',
              name: 'investment'
            }
          ]
        }
      }

      const postcode = {
        question: 'What\'s your current postcode?',
        component: 'MoleculesPostcode',
        props: {}
      }

      return {
        refinance,
        intending,
        postcode
      }
    })()
  },

  step2: {
    header: {
      title: 'Tell us a bit more about <strong>what you\'re looking for.</strong>',
      component: 'AtomsHeadline'
    },
    buttons: {
      back: true,
      main: 'Continue'
    },
    form: (() => {
      const refinancePurpose = {
        question: 'What is the reason you would like to refinance?',
        desc: 'Tell us what\'s important to you. It helps our experts match the right home loan for you. You can select multiple options',
        component: 'MoleculesSelection',
        props: {
          name: 'refinance_purpose',
          type: 'checkbox',
          cols: 1,
          mobileCols: 1,
          options: [
            {
              value: 'Pay less each month',
              label: 'Pay less each month'
            }, {
              value: 'Pay my loan off sooner',
              label: 'Pay my loan off sooner'
            }, {
              value: 'Withdraw equity',
              label: 'Withdraw equity'
            }, {
              value: 'Consolidate debt',
              label: 'Consolidate debt'
            }, {
              value: 'Split loan',
              label: 'Split loan'
            }, {
              value: 'Other',
              label: 'Other'
            }
          ]
        }
      }

      const buyingSituation = {
        question: 'What describes your home buying situation?',
        component: 'MoleculesSelection',
        props: {
          name: 'buying_situation',
          type: 'radio',
          cols: 1,
          mobileCols: 1,
          ticker: 'circle',
          options: [
            {
              value: 'Just researching my options',
              label: 'Just researching my options',
              name: 'just_researching_my_options'
            }, {
              value: 'Actively looking',
              label: 'Actively looking',
              name: 'actively_looking'
            }, {
              value: 'Plan to buy in the next 6 months',
              label: 'Plan to buy in the next 6 months',
              name: 'plan_to_buy_in_the_next_6_months'
            }, {
              value: 'Exchanged Contracts',
              label: 'Exchanged Contracts',
              name: 'exchanged_contracts'
            }
          ]
        }
      }

      return {
        refinancePurpose,
        buyingSituation
      }
    })()
  },

  step3: {
    header: {
      title: 'Tell us a bit more about <strong>what you\'re looking for.</strong>',
      component: 'AtomsHeadline'
    },
    buttons: {
      back: true,
      main: 'Continue'
    },
    form: (() => {
      const lenderReason = {
        question: 'What is important to you when choosing a lender?',
        desc: 'This helps our experts match the right home loan for you. You can select multiple options.',
        component: 'MoleculesSelection',
        props: {
          name: 'lender_reason',
          type: 'checkbox',
          cols: 1,
          mobileCols: 1,
          options: [
            {
              value: 'Offset/Redraw',
              label: 'Offset/Redraw',
              name: 'offset_or_redraw'
            }, {
              value: 'Low interest rate',
              label: 'Low interest rate',
              name: 'low_interest_rate'
            }, {
              value: 'Fixed rate',
              label: 'Fixed rate',
              name: 'fixed_rate'
            }, {
              value: 'Major lender',
              label: 'Major lender',
              name: 'major_lender'
            }, {
              value: 'Access to branch',
              label: 'Access to branch',
              name: 'access_to_branch'
            }, {
              value: 'Other',
              label: 'Other',
              name: 'other'
            }
          ]
        }
      }

      return {
        lenderReason
      }
    })()
  },

  step4: {
    header: {
      title: 'Tell us a bit more about <strong>what you\'re looking for.</strong>',
      component: 'AtomsHeadline'
    },
    buttons: {
      back: true,
      main: 'Continue'
    },
    form: (() => {
      const propertyValue = {
        question: 'What\'s the estimated value of your property?',
        desc: 'Your best guess is fine',
        component: 'AtomsInput',
        props: {
          name: 'property_value',
          placeholder: 'Property Value',
          modelType: 'money',
          maxlength: '10',
          label: '',
          hasCurrency: true
        }
      }

      const loanBalance = {
        question: 'What\'s your current loan balance?',
        desc: 'Your best guess is fine. Please note, we only service loans $200,000 and above.',
        component: 'AtomsInput',
        props: {
          name: 'loan_balance',
          placeholder: 'Loan balance',
          modelType: 'money',
          maxlength: '10',
          label: '',
          hasCurrency: true
        }
      }

      const interestRate = {
        question: 'What\'s your current interest rate?',
        desc: 'Your best guess is fine',
        component: 'AtomsInput',
        props: {
          name: 'interest_rate',
          placeholder: 'Interest rate',
          modelType: 'money',
          maxlength: '5',
          label: '',
          hasPercentage: true
        }
      }

      const loanAmount = {
        question: 'What\'s your expected purchase price?',
        desc: 'Your best guess is fine. Please note, we only service loans $200,000 and above.',
        component: 'AtomsInput',
        props: {
          name: 'loan_amount',
          placeholder: 'Loan amount',
          modelType: 'money',
          maxlength: '10',
          label: '',
          hasCurrency: true
        }
      }

      const deposit = {
        question: 'How much deposit do you have?',
        desc: 'This includes savings, equity in any existing properties, gifts or any other available funds to contribute to your purchase. Please note, we only service loans with 5% or more deposit.',
        component: 'AtomsInput',
        props: {
          name: 'deposit',
          placeholder: 'Deposit',
          modelType: 'money',
          maxlength: '10',
          label: '',
          hasCurrency: true
        }
      }

      const firstHome = {
        question: 'Is this your first home purchase?',
        component: 'MoleculesSelection',
        props: {
          name: 'first_home',
          type: 'radio',
          cols: 2,
          mobileCols: 1,
          ticker: 'circle',
          options: [
            {
              value: 'Yes',
              label: 'Yes',
              name: 'Yes'
            }, {
              value: 'No',
              label: 'No',
              name: 'No'
            }
          ]
        }
      }

      return {
        propertyValue,
        loanBalance,
        interestRate,
        loanAmount,
        deposit,
        firstHome
      }
    })()
  },

  step5: {
    header: {
      title: 'Tell us a bit more about <strong>what you\'re looking for.</strong>',
      component: 'AtomsHeadline'
    },
    buttons: {
      back: true,
      main: 'Continue'
    },
    form: (() => {
      const interestType = {
        question: 'What interest rate type are you after?',
        component: 'MoleculesSelection',
        props: {
          name: 'interest_type',
          type: 'radio',
          cols: 1,
          mobileCols: 1,
          ticker: 'circle',
          options: [
            {
              value: 'Fixed',
              label: 'Fixed',
              name: 'Fixed'
            }, {
              value: 'Variable',
              label: 'Variable',
              name: 'Variable'
            }, {
              value: 'Split',
              label: 'Split',
              name: 'Split'
            }, {
              value: 'Unsure',
              label: 'Unsure',
              name: 'Unsure'
            }
          ]
        }
      }
      const interestTypeLoan = {
        question: 'What interest rate type are you after?',
        component: 'MoleculesSelection',
        props: {
          name: 'interest_type_loan',
          type: 'radio',
          cols: 1,
          mobileCols: 1,
          ticker: 'circle',
          options: [
            {
              value: 'Fixed',
              label: 'Fixed',
              name: 'Fixed'
            }, {
              value: 'Variable',
              label: 'Variable',
              name: 'Variable'
            }, {
              value: 'Unsure',
              label: 'Unsure',
              name: 'Unsure'
            }
          ]
        }
      }

      return {
        interestType,
        interestTypeLoan
      }
    })()
  },

  step6: {
    header: {
      title: 'Tell us a bit more about <strong>what you\'re looking for.</strong>',
      component: 'AtomsHeadline'
    },
    buttons: {
      back: true,
      main: 'Save & continue'
    },
    form: (() => {
      const buyingProperty = {
        question: 'Who will be applying for the loan?',
        component: 'MoleculesSelection',
        props: {
          name: 'buying_property',
          type: 'radio',
          cols: 1,
          mobileCols: 1,
          ticker: 'circle',
          options: [
            {
              value: 'Just me',
              label: 'Just me',
              name: 'Just me'
            }, {
              value: 'Me and my partner',
              label: 'Me and my partner',
              name: 'Me and my partner'
            }, {
              value: 'Other / Unsure',
              label: 'Other / Unsure',
              name: 'Other / Unsure'
            }
          ]
        }
      }
      const totalIncome = {
        question: 'What is your total annual income?',
        desc: 'This includes salary, rental income or another form of income.',
        component: 'AtomsInput',
        props: {
          name: 'income',
          placeholder: 'Income',
          modelType: 'money',
          maxlength: '10',
          label: '',
          hasCurrency: true
        }
      }
      const totalOtherIncome = {
        question: 'What is the total annual income of any other applicant?',
        desc: 'This includes salary, rental income or another form of income.',
        component: 'AtomsInput',
        props: {
          name: 'other_income',
          placeholder: 'Other applicant income ',
          modelType: 'money',
          maxlength: '10',
          label: '',
          hasCurrency: true
        }
      }

      return {
        buyingProperty,
        totalIncome,
        totalOtherIncome
      }
    })()
  }
}

export const FORM_STEPS = {
  home_loans: [
    {
      label: 'About you',
      icon: '/icons/life-insurance/identity-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    },
    {
      label: 'Loan details',
      icon: '/icons/home-loans/loan-details.svg',
      iconDimensions: {
        width: 16,
        height: 18
      }
    },
    {
      label: 'Income',
      icon: '/icons/home-loans/income.svg',
      iconDimensions: {
        width: 16,
        height: 18
      }
    },
    {
      label: 'Compare',
      icon: '/icons/life-insurance/compare-card.svg',
      iconDimensions: {
        width: 24,
        height: 24
      }
    }
  ]
}

export const FORM_SUMMARY_MAP = {
  refinance: {
    label: 'Purpose',
    icon: 'user-pin'
  },
  intending: {
    label: 'Property',
    icon: 'money-bag'
  },
  postcode: {
    label: 'Postcode',
    icon: 'location-outline'
  },
  refinance_purpose: {
    label: 'Refinance reason',
    icon: 'home-check'
  },
  buying_situation: {
    label: 'Buying situation',
    icon: 'home-needs-outline'
  },
  lender_reason: {
    label: 'Lender feature',
    icon: 'home-outline-check'
  },
  property_value: {
    label: 'Estimated value',
    icon: 'home-dollar'
  },
  loan_balance: {
    label: 'Loan amount',
    icon: 'money-bag'
  },
  interest_rate: {
    label: 'Current interest rate',
    icon: 'circle-percentage'
  },
  interest_type: {
    label: 'Interest rate type',
    icon: 'home-min'
  },
  interest_type_loan: {
    label: 'Interest rate type',
    icon: 'home-min'
  },
  buying_property: {
    label: 'Interest rate',
    icon: 'home-needs-outline'
  },
  loan_amount: {
    label: 'Purchase price',
    icon: 'user-pin'
  },
  deposit: {
    label: 'Deposit',
    icon: 'money-bag'
  },
  first_home: {
    label: 'First home purchase',
    icon: 'home-needs-outline'
  }
}

export const CALCULATORS = [
  'Refinance',
  'Borrowing Power',
  'Stamp Duty',
  'Buying Costs',
  'Selling Costs',
  'Deposit',
  'Budget Planner'
]

export const CALCULATOR_DISCLAIMER = {
  refinance: [
    'Disclaimer: The results from this calculator should be treated as a guide only and is not a prediction or professional financial advice and should not be relied on as true indication of home repayment, or quotes or pre-qualifications for any loan. You should consider getting advice from a licensed finance professional before making any financial decision.',
    'Results are based on information you have provided and do not take any of your personal circumstances into account. Using this calculator does not guarantee you will be eligible for a loan. You will need to satisfy your lender\'s lending criteria.',
    'Compare Club accepts no responsibility for any losses arising from any use of or reliance upon any calculations or conclusions reached using the calculator.',
    'Information such as interest rates quoted, and default figures, and formulae used in the assumptions are subject to change without notice.'
  ],
  borrowingPower: [
    'Disclaimer: The results from this calculator should be treated as a guide only and is not a prediction or professional financial advice and should not be relied on as true indication of borrowing power, or quotes or pre-qualifications for any loan. You should consider getting advice from a licensed finance professional before making any financial decision.',
    'Results are based on information you have provided and do not take any of your personal circumstances into account. Using this calculator does not guarantee you will be eligible for a loan. You will need to satisfy your lender\'s lending criteria.',
    'Compare Club accepts no responsibility for any losses arising from any use of or reliance upon any calculations or conclusions reached using the calculator.',
    'Information such as interest rates quoted, and default figures, and formulae used in the assumptions are subject to change without notice.'
  ],
  stampDuty: [
    'Disclaimer: The results from this calculator should be treated as a guide only and is not a prediction or professional financial advice and should not be relied on as true indication of stamp duty, or quotes or pre-qualifications for any loan. You should consider getting advice from a licensed finance professional before making any financial decision.',
    'Results are based on information you have provided and do not take any of your personal circumstances into account. Using this calculator does not guarantee you will be eligible for a loan. You will need to satisfy your lender\'s lending criteria.',
    'Compare Club accepts no responsibility for any losses arising from any use of or reliance upon any calculations or conclusions reached using the calculator.',
    'Information such as interest rates quoted, and default figures, and formulae used in the assumptions are subject to change without notice.'
  ],
  buyingCosts: [
    'Disclaimer: The results from this calculator should be treated as a guide only and is not a prediction or professional financial advice and should not be relied on as true indication of buying and selling costs, or quotes or pre-qualifications for any loan. You should consider getting advice from a licensed finance professional before making any financial decision.',
    'Results are based on information you have provided and do not take any of your personal circumstances into account. Using this calculator does not guarantee you will be eligible for a loan. You will need to satisfy your lender\'s lending criteria.',
    'Compare Club accepts no responsibility for any losses arising from any use of or reliance upon any calculations or conclusions reached using the calculator.',
    'Information such as interest rates quoted, and default figures, and formulae used in the assumptions are subject to change without notice.'
  ],
  sellingCosts: [
    'Disclaimer: The results from this calculator should be treated as a guide only and is not a prediction or professional financial advice and should not be relied on as true indication of buying and selling costs, or quotes or pre-qualifications for any loan. You should consider getting advice from a licensed finance professional before making any financial decision.',
    'Results are based on information you have provided and do not take any of your personal circumstances into account. Using this calculator does not guarantee you will be eligible for a loan. You will need to satisfy your lender\'s lending criteria.',
    'Compare Club accepts no responsibility for any losses arising from any use of or reliance upon any calculations or conclusions reached using the calculator.',
    'Information such as interest rates quoted, and default figures, and formulae used in the assumptions are subject to change without notice.'
  ],
  deposit: [
    'Disclaimer: The results from this calculator should be treated as a guide only and is not a prediction or professional financial advice and should not be relied on as true indication of home loan deposit, or quotes or pre-qualifications for any loan. You should consider getting advice from a licensed finance professional before making any financial decision.',
    'Results are based on information you have provided and do not take any of your personal circumstances into account. Using this calculator does not guarantee you will be eligible for a loan. You will need to satisfy your lender\'s lending criteria.',
    'Compare Club accepts no responsibility for any losses arising from any use of or reliance upon any calculations or conclusions reached using the calculator.',
    'Information such as interest rates quoted, and default figures, and formulae used in the assumptions are subject to change without notice.'
  ],
  budgetPlanner: [
    'Disclaimer: The results from this calculator should be treated as a guide only and is not a prediction or professional financial advice and should not be relied on as true indication of a budget planner, or quotes or pre-qualifications for any loan. You should consider getting advice from a licensed finance professional before making any financial decision.',
    'Results are based on information you have provided and do not take any of your personal circumstances into account. Using this calculator does not guarantee you will be eligible for a loan. You will need to satisfy your lender\'s lending criteria.',
    'Compare Club accepts no responsibility for any losses arising from any use of or reliance upon any calculations or conclusions reached using the calculator.',
    'Information such as interest rates quoted, and default figures, and formulae used in the assumptions are subject to change without notice.'
  ]
}
